<template>
  <div id="news">
    <ul>
      <li class="news-header">
        <h2><span class="news-header-title">お知らせ</span></h2>
        <link-button v-bind:link="`/news`" v-bind:title="`お知らせ一覧`" />
      </li>
      <li class="news-list" v-for="(item, index) in items" :key="index">
        <router-link
          v-bind:to="{
            name: 'News',
          }"
          exact
        >
          <span class="news-date">
            {{ item.date }}
          </span>
          <span class="content-title">
            {{ item.title }}
          </span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'NewsList',
  data() {
    return {
      items: [
        {
          date: '2025-07-12',
          title:
            '「Beyond EC」 新サービスの追加に伴う3シリーズ展開のご案内及び、受信機(BEC-100)の機能向上、付属品追加による価格改定のご案内',
        },
        {
          date: '2024-03-30',
          title: '株式会社ビーアッサ　事務所移転のご案内',
        },
        {
          date: '2023-02-17',
          title:
            '電池レス特定小電力無線とWi-Fiを組み合せた「新・呼び出しシステム」。今春発売予定の新商品「Beyond EC（ビヨンドイーシー）」予約受付け開始のご案内',
        },
        {
          date: '2023-02-14',
          title:
            'マウス／タッチパネルの簡単操作！リモートリプライコールPC商品ページ公開のご案内',
        },
        {
          date: '2023-02-14',
          title:
            '複数台送信機システムを実現！リモートリプライコール管理機のご案内',
        },
      ],
    }
  },
}
</script>

<style scoped>
h2 {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: transparent;
  display: unset;
}

#news {
  width: 90%;
  max-width: 1000px;
  margin: 0 auto 30px auto;
}

#news ul {
  justify-content: center;

  list-style: none;
  padding: 0;
}

#news ul li {
  line-height: 35px;

  border-bottom: 1px solid #ddd;
}

#news ul li a {
  text-decoration: none;
}

.news-header {
  position: relative;

  padding: 5px;
}

.news-header .news-header-title {
  font-weight: bold;

  padding-left: 5px;

  color: rgb(26, 87, 167);
  border-left: 3px solid rgb(80, 172, 252);
}

.news-list {
  font-size: 14px;

  padding-left: 10px;
}

.news-list .news-date {
  font-weight: bold;

  color: rgb(26, 161, 230);
}

.news-list .content-title {
  padding-left: 20px;

  color: #4d4d4d;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/News.vue